import { t } from '@transifex/native';

import { flashes } from 'pkg/actions';
import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import { create as modelsCreate } from 'pkg/api/models/actions';
import * as sdk from 'pkg/core/sdk';

export interface CreatePricePayload {
	productId: number;
	cost: number;
	currency: string;
	description?: string;
	recurring: boolean;
	recurringInterval?: string;
	recurringIntervalCount?: number;
	taxRateId?: number;
	title: string;
}

export const create = async (
	organizationId: number,
	payload: CreatePricePayload,
	recurringOptionString: models.providerSettings.RecurringOptionStrings,
	providerSettings: models.providerSettings.ProviderSettings
): Promise<[Response, any]> => {
	if (payload.recurring && recurringOptionString !== 'custom') {
		const recurringOption =
			providerSettings.availableRecurringOptions[recurringOptionString];

		payload.recurringInterval = recurringOption.recurringInterval;
		payload.recurringIntervalCount = recurringOption.recurringIntervalCount;
	}

	const [request, response] = await modelsCreate<
		CreatePricePayload,
		models.productPrice.ProductPrice
	>(endpoints.ProductPrices.Create(organizationId), payload);

	if (!request.ok) {
		return [request, null];
	}

	return [request, response];
};

export interface UpdatePricePayload {
	description?: string;
	taxRateId?: number;
	title?: string;
	archived?: boolean;
}

export const update = async (
	organizationId: number,
	priceId: number,
	payload: UpdatePricePayload
): Promise<boolean> => {
	const request = await sdk.patch(
		endpoints.ProductPrices.Update(organizationId, priceId),
		{},
		payload
	);

	if (!request.ok) {
		flashes.show({
			title: t('Something went wrong!'),
			message: t(
				`If you think this error isn't supposed to happen, please contact 360Player support.`
			),
		});
		return false;
	}

	return true;
};
